(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mdb", [], factory);
	else if(typeof exports === 'object')
		exports["mdb"] = factory();
	else
		root["mdb"] = factory();
})(this, function() {
return 